/* Ausgewählte Bewertungen aus Reviews.io (Timeline-API) als eigene Karten rendern.
   Keine statischen Sterne: Sterne und Texte kommen live aus Reviews.io. */
(function () {
  var STAR = '<svg width="16" height="16" viewBox="0 0 24 24" aria-hidden="true" focusable="false"><path d="M12 3l2.7 5.6 6.1.9-4.4 4.3 1 6.1L12 17l-5.4 2.9 1-6.1L3.2 9.5l6.1-.9z"/></svg>';

  // Sternzeile als SVGs, gefüllte Sterne in currentColor
  function stars(rating) {
    var html = '';
    for (var i = 1; i <= 5; i++) {
      html += '<span class="bv-star' + (i <= rating ? ' bv-star--on' : '') + '">' + STAR + '</span>';
    }
    return '<span class="bv-review__stars" aria-label="' + rating + ' von 5 Sternen">' + html + '</span>';
  }

  // Datum aus "YYYY-MM-DD HH:MM:SS" als DD.MM.YYYY
  function formatDate(value) {
    var m = /^(\d{4})-(\d{2})-(\d{2})/.exec(value || '');
    return m ? m[3] + '.' + m[2] + '.' + m[1] : '';
  }

  function el(tag, className, text) {
    var node = document.createElement(tag);
    if (className) node.className = className;
    if (text) node.textContent = text;
    return node;
  }

  function renderCard(review) {
    var card = el('figure', 'bv-card bv-review');
    var head = el('div', 'bv-review__head');
    head.innerHTML = stars(Number(review.rating) || 0);
    if (review.order_id) head.appendChild(el('span', 'bv-review__badge', 'Verifizierter Kauf'));
    card.appendChild(head);
    if (review.review_title) card.appendChild(el('p', 'bv-review__title', review.review_title));
    var quote = el('blockquote', 'bv-quote-card__text', review.comments || '');
    card.appendChild(quote);
    var cap = el('figcaption');
    cap.appendChild(el('p', 'bv-quote-card__name', review.author || 'Kundin oder Kunde'));
    var meta = [];
    if (review.address) meta.push(review.address);
    var date = formatDate(review.date_created);
    if (date) meta.push(date);
    if (review.product_name) meta.push(review.product_name);
    cap.appendChild(el('p', 'bv-quote-card__role', meta.join(' · ')));
    card.appendChild(cap);
    return card;
  }

  function init(root) {
    var store = root.dataset.store;
    var grid = root.querySelector('[data-bv-reviews-grid]');
    var summary = root.querySelector('[data-bv-reviews-summary]');
    if (!store || !grid) return;
    var params = new URLSearchParams({
      type: 'product_review',
      store: store,
      sort: 'date_desc',
      page: '1',
      per_page: String(Math.min(30, (Number(root.dataset.max) || 6) * 3)),
      minRating: root.dataset.minRating || '5'
    });
    if (root.dataset.sku) params.set('sku', root.dataset.sku);
    fetch('https://api.reviews.io/timeline/data?' + params.toString())
      .then(function (r) { return r.ok ? r.json() : Promise.reject(r.status); })
      .then(function (data) {
        var minLength = Number(root.dataset.minLength || 0);
        var maxItems = Number(root.dataset.max || 6);
        // Sehr kurze Texte (z. B. „Unser“) aussortieren; die Anzahl bleibt auf das Maximum begrenzt
        var items = (data.timeline || []).map(function (t) { return t._source || t; })
          .filter(function (r) { return String(r.comments || '').trim().length >= minLength; })
          .slice(0, maxItems);
        if (!items.length) { root.hidden = true; return; }
        grid.innerHTML = '';
        items.forEach(function (review) { grid.appendChild(renderCard(review)); });
        // Ehrliche Gesamtwertung: Durchschnitt und Anzahl aller Bewertungen, plus Hinweis auf die Auswahl
        var stats = data.stats || {};
        if (summary && stats.review_count) {
          var avg = String(Number(stats.average_rating || 0).toFixed(1)).replace('.', ',');
          var text = (root.dataset.summaryText || '')
            .replace('{avg}', avg)
            .replace('{count}', stats.review_count)
            .replace('{min}', root.dataset.minRating || '5');
          summary.textContent = text;
          summary.hidden = false;
        }
        root.hidden = false;
      })
      .catch(function () {
        // Bei Fehlern (Netz, Consent) bleibt die Section ausgeblendet, statt leer zu wirken
        root.hidden = true;
      });
  }

  document.querySelectorAll('[data-bv-reviews-home]').forEach(init);
  document.addEventListener('shopify:section:load', function (e) {
    e.target.querySelectorAll('[data-bv-reviews-home]').forEach(init);
  });
})();
